import { CFade } from '@coreui/react';
import React, { Suspense } from 'react';
import {
  Route,
  Switch,
} from 'react-router-dom';
import authRoutes from '../core/authRoutes';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse" />
  </div>
);

const TheAuthLayout = () => (
  <div className="auth-layout">
    <Suspense fallback={loading}>
      <Switch>
        {authRoutes.map((route) => route.component && (
        <Route
          key={route.name}
          path={route.path}
          exact={route.exact}
          name={route.name}
          render={(props) => (
            <CFade>
              <route.component {...props} />
            </CFade>
          )}
        />
        ))}
      </Switch>
    </Suspense>
  </div>
);

export const AuthRouter = {
  path: '/auth',
  component: TheAuthLayout,
  routes: authRoutes,
};

export default TheAuthLayout;
